
const FONT_SIZE_DEFAULT = {
    '--font-size-default' : '14px',
    '--font-size-small'   : '13px',
    '--font-size-tiny'    : '12px',
    '--font-size-micro'   : '11px', // used with uppercase in ui5-grid-header
    '--font-size-bigger'  : '15px',

    '--font-size-h1'      : '24px',
    '--font-size-h2'      : '20px',
    '--font-size-h3'      : '17px',
}

const FONT_SIZE_SMALL = {
    '--font-size-default' : '13px',
    '--font-size-small'   : '12px',
    '--font-size-tiny'    : '11px',
    '--font-size-micro'   : '11px', // used with uppercase in ui5-grid-header
    '--font-size-bigger'  : '15px',

    '--font-size-h1'      : '24px',
    '--font-size-h2'      : '20px',
    '--font-size-h3'      : '16px',
}

const FONT_SIZES = {
    'small'     : FONT_SIZE_SMALL,
    'default'   : FONT_SIZE_DEFAULT
}

export enum SKIN_FONT_SIZE {
    DEFAULT      = 'default',
    SMALL        = 'small'
}


export default class FontSize {

    public currentSize : SKIN_FONT_SIZE = SKIN_FONT_SIZE.DEFAULT

    constructor(initFontSize:SKIN_FONT_SIZE) {
        // this.currentSize = null
        this.setFontSize(initFontSize)
    }

    setFontSize(fontSize : SKIN_FONT_SIZE) {

        if (fontSize===this.currentSize) return;

        // make sure palette exists
        if (!FONT_SIZES[fontSize]) fontSize = SKIN_FONT_SIZE.DEFAULT

        this.currentSize = fontSize;
        this.applyDOMCssVariables();
    }

    applyDOMCssVariables() {
        const sizeConfig = FONT_SIZES[this.currentSize]
        const root = document.querySelector(':root');

        _.map(sizeConfig, (value, key)=>{
            // console.log(">", value, key)

            // @ts-ignore
            root.style.setProperty(key, value)
        })

    }

    fontSizes():SKIN_FONT_SIZE[] {
        return [
            SKIN_FONT_SIZE.SMALL,
            SKIN_FONT_SIZE.DEFAULT
        ]
    }
}